import React from "react";
import { Link } from "react-router-dom";

const Home = () => {
  return (
    <>
      <div class="bg-primary">
        <section className="bg-center bg-no-repeat bg-[url('https://www.theofficepass.com/toppings/wp-content/uploads/2020/04/wfh-cad-designers-scaled.jpg')] bg-primary bg-blend-multiply">
          <div className="px-4 mx-auto max-w-screen-xl text-center py-24 lg:py-56">
            <h1 className="mb-4 text-4xl font-extrabold tracking-tight leading-none text-primary md:text-5xl lg:text-6xl">
              Find Your Dream Job With Us!
            </h1>
            <p className="mb-8 text-lg font-normal text-secondary lg:text-xl sm:px-16 lg:px-48">
              Here with Job Route, we get a suitable job according to your
              profile today
            </p>
            <div className="flex flex-col space-y-4 sm:flex-row sm:justify-center sm:space-y-0">
              <Link to="/Vacancy">
                <span className="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-white rounded-lg bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300">
                  Get started
                  <svg
                    className="w-3.5 h-3.5 ms-2 rtl:rotate-180"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 10"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M1 5h12m0 0L9 1m4 4L9 9"
                    />
                  </svg>
                </span>
              </Link>
              <Link to="/About">
                <span className="inline-flex justify-center hover:text-gray-900 items-center py-3 px-5 sm:ms-4 text-base font-medium text-center text-white rounded-lg border border-white hover:bg-gray-100 focus:ring-4 focus:ring-gray-400">
                  About
                </span>
              </Link>
            </div>
          </div>
        </section>
        <section className="py-10 bg-white sm:py-16 lg:py-24">
          <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div className="grid items-center grid-cols-1 lg:grid-cols-2 gap-x-12 xl:gap-x-24 gap-y-12">
              <div className="relative lg:mb-12">
                <img
                  className="absolute -right-0 -bottom-8 xl:-bottom-12 xl:-right-4"
                  src="https://cdn.rareblocks.xyz/collection/celebration/images/content/3/dots-pattern.svg"
                  alt=""
                />
                <div className="pl-12 pr-6">
                  <img
                    className="relative"
                    src="https://cdn.rareblocks.xyz/collection/celebration/images/content/3/girl-working-on-laptop.jpg"
                    alt=""
                  />
                </div>
              </div>
              <div className="2xl:pl-16">
                <h2 className="text-3xl font-bold leading-tight text-black sm:text-4xl lg:text-5xl lg:leading-tight">
                  We make things easy for You.
                </h2>
                <p className="text-xl leading-relaxed text-gray-900 mt-9">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit.
                  Mollitia nam maiores saepe necessitatibus inventore natus
                </p>
                <p className="mt-6 text-xl leading-relaxed text-gray-900">
                  Lorem, ipsum dolor sit amet consectetur adipisicing elit. Cum
                  temporibus, voluptatum sint exercitationem deleniti blanditiis
                  minima vel repellendus mollitia? Aspernatur officiis ex
                  maiores consequatur eius! Enim laudantium odit autem aliquid.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className="py-10 bg-gray-200 sm:py-16 lg:py-24">
          <div className="px-4 mx-auto max-w-7xl sm:px-6 lg:px-8">
            <div className="max-w-2xl mx-auto text-center">
              <h2 className="text-3xl font-bold leading-tight text-black sm:text-4xl lg:text-5xl">
                What our customers say
              </h2>
              <p className="max-w-lg mx-auto mt-4 text-base leading-relaxed text-gray-600">
                Amet minim mollit non deserunt ullamco est sit aliqua dolor do
                amet sint. Velit officia consequat duis.
              </p>
            </div>
            <div className="grid grid-cols-1 gap-6 px-4 mt-12 sm:px-0 xl:mt-20 xl:grid-cols-4 sm:grid-cols-2">
              <div className="overflow-hidden bg-white rounded-md">
                <div className="px-5 py-6">
                  <div className="flex items-center justify-between">
                    <img
                      className="flex-shrink-0 object-cover w-10 h-10 rounded-full"
                      src="https://cdn.rareblocks.xyz/collection/celebration/images/testimonials/7/avatar-1.jpg"
                      alt=""
                    />
                    <div className="min-w-0 ml-3 mr-auto">
                      <p className="text-base font-semibold text-black truncate">
                        Darrell Steward
                      </p>
                      <p className="text-sm text-gray-600 truncate">@darrels</p>
                    </div>
                    <a href="#" title className="inline-block text-sky-500">
                      <svg
                        className="w-6 h-6"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z" />
                      </svg>
                    </a>
                  </div>
                  <blockquote className="mt-5">
                    <p className="text-base text-gray-800">
                      You made it so simple. My new site is so much faster and
                      easier to work with than my old site. I just choose the
                      page, make the change and click save.
                      <span className="block text-sky-500">#another</span>
                    </p>
                  </blockquote>
                </div>
              </div>
              <div className="overflow-hidden bg-white rounded-md">
                <div className="px-5 py-6">
                  <div className="flex items-center justify-between">
                    <img
                      className="flex-shrink-0 object-cover w-10 h-10 rounded-full"
                      src="https://cdn.rareblocks.xyz/collection/celebration/images/testimonials/7/avatar-2.jpg"
                      alt=""
                    />
                    <div className="min-w-0 ml-3 mr-auto">
                      <p className="text-base font-semibold text-black truncate">
                        Leslie Alexander
                      </p>
                      <p className="text-sm text-gray-600 truncate">@lesslie</p>
                    </div>
                    <a href="#" title className="inline-block text-sky-500">
                      <svg
                        className="w-6 h-6"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z" />
                      </svg>
                    </a>
                  </div>
                  <blockquote className="mt-5">
                    <p className="text-base text-gray-800">
                      Simply the best. Better than all the rest. I’d recommend
                      this product to beginners and advanced users.
                      <span className="block text-sky-500">#Celebration</span>
                    </p>
                  </blockquote>
                </div>
              </div>
              <div className="overflow-hidden bg-white rounded-md">
                <div className="px-5 py-6">
                  <div className="flex items-center justify-between">
                    <img
                      className="flex-shrink-0 object-cover w-10 h-10 rounded-full"
                      src="https://cdn.rareblocks.xyz/collection/celebration/images/testimonials/7/avatar-3.jpg"
                      alt=""
                    />
                    <div className="min-w-0 ml-3 mr-auto">
                      <p className="text-base font-semibold text-black truncate">
                        Jenny Wilson
                      </p>
                      <p className="text-sm text-gray-600 truncate">
                        @jennywilson
                      </p>
                    </div>
                    <a href="#" title className="inline-block text-sky-500">
                      <svg
                        className="w-6 h-6"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z" />
                      </svg>
                    </a>
                  </div>
                  <blockquote className="mt-5">
                    <p className="text-base text-gray-800">
                      This is a top quality product. No need to think twice
                      before making it live on web.
                      <span className="block text-sky-500">#make_it_fast</span>
                    </p>
                  </blockquote>
                </div>
              </div>
              <div className="overflow-hidden bg-white rounded-md">
                <div className="px-5 py-6">
                  <div className="flex items-center justify-between">
                    <img
                      className="flex-shrink-0 object-cover w-10 h-10 rounded-full"
                      src="https://cdn.rareblocks.xyz/collection/celebration/images/testimonials/7/avatar-4.jpg"
                      alt=""
                    />
                    <div className="min-w-0 ml-3 mr-auto">
                      <p className="text-base font-semibold text-black truncate">
                        Kristin Watson
                      </p>
                      <p className="text-sm text-gray-600 truncate">
                        @kristinwatson2
                      </p>
                    </div>
                    <a href="#" title className="inline-block text-sky-500">
                      <svg
                        className="w-6 h-6"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z" />
                      </svg>
                    </a>
                  </div>
                  <blockquote className="mt-5">
                    <p className="text-base text-gray-800">
                      YFinally, I’ve found a template that covers all bases for
                      a bootstrapped startup. We were able to launch in days,
                      not months.
                      <span className="block text-sky-500">#Celebration</span>
                    </p>
                  </blockquote>
                </div>
              </div>
              <div className="overflow-hidden bg-white rounded-md">
                <div className="px-5 py-6">
                  <div className="flex items-center justify-between">
                    <img
                      className="flex-shrink-0 object-cover w-10 h-10 rounded-full"
                      src="https://cdn.rareblocks.xyz/collection/celebration/images/testimonials/7/avatar-5.jpg"
                      alt=""
                    />
                    <div className="min-w-0 ml-3 mr-auto">
                      <p className="text-base font-semibold text-black truncate">
                        Guy Hawkins
                      </p>
                      <p className="text-sm text-gray-600 truncate">
                        @jennywilson
                      </p>
                    </div>
                    <a href="#" title className="inline-block text-sky-500">
                      <svg
                        className="w-6 h-6"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z" />
                      </svg>
                    </a>
                  </div>
                  <blockquote className="mt-5">
                    <p className="text-base text-gray-800">
                      This is a top quality product. No need to think twice
                      before making it live on web.
                      <span className="block text-sky-500">#make_it_fast</span>
                    </p>
                  </blockquote>
                </div>
              </div>
              <div className="overflow-hidden bg-white rounded-md">
                <div className="px-5 py-6">
                  <div className="flex items-center justify-between">
                    <img
                      className="flex-shrink-0 object-cover w-10 h-10 rounded-full"
                      src="https://cdn.rareblocks.xyz/collection/celebration/images/testimonials/7/avatar-6.jpg"
                      alt=""
                    />
                    <div className="min-w-0 ml-3 mr-auto">
                      <p className="text-base font-semibold text-black truncate">
                        Marvin McKinney
                      </p>
                      <p className="text-sm text-gray-600 truncate">@darrels</p>
                    </div>
                    <a href="#" title className="inline-block text-sky-500">
                      <svg
                        className="w-6 h-6"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z" />
                      </svg>
                    </a>
                  </div>
                  <blockquote className="mt-5">
                    <p className="text-base text-gray-800">
                      With Celebration, it’s quicker with the customer, the
                      customer is more ensured of getting exactly what they
                      ordered, and I’m all for the efficiency.
                      <span className="block text-sky-500">#dev #tools</span>
                    </p>
                  </blockquote>
                </div>
              </div>
              <div className="overflow-hidden bg-white rounded-md">
                <div className="px-5 py-6">
                  <div className="flex items-center justify-between">
                    <img
                      className="flex-shrink-0 object-cover w-10 h-10 rounded-full"
                      src="https://cdn.rareblocks.xyz/collection/celebration/images/testimonials/7/avatar-7.jpg"
                      alt=""
                    />
                    <div className="min-w-0 ml-3 mr-auto">
                      <p className="text-base font-semibold text-black truncate">
                        Annette Black
                      </p>
                      <p className="text-sm text-gray-600 truncate">@darrels</p>
                    </div>
                    <a href="#" title className="inline-block text-sky-500">
                      <svg
                        className="w-6 h-6"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z" />
                      </svg>
                    </a>
                  </div>
                  <blockquote className="mt-5">
                    <p className="text-base text-gray-800">
                      You made it so simple. My new site is so much faster and
                      easier to work with than my old site. I just choose the
                      page, make the change and click save.
                      <span className="block text-sky-500">#another</span>
                    </p>
                  </blockquote>
                </div>
              </div>
              <div className="overflow-hidden bg-white rounded-md">
                <div className="px-5 py-6">
                  <div className="flex items-center justify-between">
                    <img
                      className="flex-shrink-0 object-cover w-10 h-10 rounded-full"
                      src="https://cdn.rareblocks.xyz/collection/celebration/images/testimonials/7/avatar-8.jpg"
                      alt=""
                    />
                    <div className="min-w-0 ml-3 mr-auto">
                      <p className="text-base font-semibold text-black truncate">
                        Floyd Miles
                      </p>
                      <p className="text-sm text-gray-600 truncate">@darrels</p>
                    </div>
                    <a href="#" title className="inline-block text-sky-500">
                      <svg
                        className="w-6 h-6"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M19.633 7.997c.013.175.013.349.013.523 0 5.325-4.053 11.461-11.46 11.461-2.282 0-4.402-.661-6.186-1.809.324.037.636.05.973.05a8.07 8.07 0 0 0 5.001-1.721 4.036 4.036 0 0 1-3.767-2.793c.249.037.499.062.761.062.361 0 .724-.05 1.061-.137a4.027 4.027 0 0 1-3.23-3.953v-.05c.537.299 1.16.486 1.82.511a4.022 4.022 0 0 1-1.796-3.354c0-.748.199-1.434.548-2.032a11.457 11.457 0 0 0 8.306 4.215c-.062-.3-.1-.611-.1-.923a4.026 4.026 0 0 1 4.028-4.028c1.16 0 2.207.486 2.943 1.272a7.957 7.957 0 0 0 2.556-.973 4.02 4.02 0 0 1-1.771 2.22 8.073 8.073 0 0 0 2.319-.624 8.645 8.645 0 0 1-2.019 2.083z" />
                      </svg>
                    </a>
                  </div>
                  <blockquote className="mt-5">
                    <p className="text-base text-gray-800">
                      My new site is so much faster and easier to work with than
                      my old site. I just choose the page, make the change and
                      click save.
                      <span className="block text-sky-500">#Celebration</span>
                    </p>
                  </blockquote>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Home;
